import { Component , Input } from '@angular/core';
import { Button } from '../button/button.component';

@Component({
  selector: 'app-titledescription',
  templateUrl: './titledescription.html',
  styleUrl: './titledescription.scss'
})
export class Titledescription {
  @Input() title : string = ''
  @Input() subtitle : string = ''
  @Input() description : string = ''

}
